import { useQuasar } from "quasar";
import PDialogForm from "src/components/PDialogForm.vue";
import { unref } from "vue";

export function useHold({ closeForm, formData }) {
  const $q = useQuasar();

  const { holdPaymentRequest } = usePaymentRequestStore();

  const loading = ref(false);

  const onConfirm = async (dialog, reason) => {
    try {
      loading.value = true;

      const payload = {
        _id: unref(formData)._id,
        reason: unref(reason),
      };

      await holdPaymentRequest(payload);

      closeForm();

      dialog?.hide();
    } catch (error) {
      console.error(error);
    } finally {
      loading.value = false;
    }
  };

  const confirmHold = () => {
    const holdDialog = $q.dialog({
      component: PDialogForm,
      componentProps: {
        title: `Hold Payment for request  ${unref(formData)?.internal_number}`,
        submitLabel: "Submit",
        cancellable: false,
        loading,
        form: {
          input: {
            type: "textarea",
            autogrow: true,
            required: true,
            placeholder: "Enter Reason",
            label: "Hold reason",
            labelClasses: "text-sm text-neutral text-weight-bold",
            help: "Please state the reason to hold this payment",
            helpClasses: "text-sm text-neutral-70 q-mt-none",
          },
        },
        onConfirm: (reason) => onConfirm(holdDialog, reason),
      },
    });
  };

  const holdButton = computed(() => {
    return {
      loading: unref(loading),
      label: "On Hold",
      type: "button",
      onClick: confirmHold,
    };
  });

  return {
    holdButton,
  };
}
